/**
 * Actions são responsáveis por chamar as mutations;
 * Também são responsáveis por fazer as requisições HTTP da aplicação
 */

import * as types from './mutation-types'
import * as storage from '../storage'

import services from '@/http'

/**
 * Inicializa o store
 * @param {Function} commit
 */
export const InitializationStore = async ({ dispatch }) => {
    console.log('InitializationStore')
    await dispatch('ActionUpdateState')
}

/**
 * Realiza o login
 * @param {Function} dispatch
 * @param {Object} payload
 */
export const ActionDoLogin = async ({ dispatch }, payload) => {
    const resPromisse = services.auth.login(payload)

    await resPromisse.then(res => {
        dispatch('ActionSetUser', res.data.user)
        dispatch('ActionSetToken', res.data.login.access_token)
    }).catch(err => {
        console.error('Error: ', err)
    })

    return resPromisse
}

/**
 * Realiza o cadastro
 * @param {Function} dispatch
 * @param {Object} payload
 */
export const ActionDoCreate = async ({ dispatch }, payload) => {
    await services.auth.create(payload).then(res => {
        if (res.data.success) {
            dispatch('ActionSetUser', res.data.user)
            dispatch('ActionSetToken', res.data.login.access_token)
            return Promise.resolve(res)
        } else {
            return Promise.reject(res)
        }
    }).catch(err => {
        return Promise.reject(err)
    })
}

/**
 * Verifica se o token existe e se é válido
 *
 * @param {Function} dispatch
 * @param {Object} state
 */
export const ActionCheckToken = async ({ dispatch, state }) => {
    await dispatch('ActionUpdateState')

    // Se existe o token no state
    if (state.token) {
        return Promise.resolve(state.token)
    } else {
        dispatch('ActionSignOut')
        return Promise.reject(new Error('Token Inválido'))
    }
}

/**
 * Valida o token no servidor
 *
 * @param {Function} dispatch
 */
export const ActionLoadSession = ({ dispatch }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const { data: { user } } = await services.auth.loadSession()
            dispatch('ActionSetUser', user)
            resolve()
        } catch (err) {
            console.error(err)
            dispatch('ActionSignOut')
            reject(err)
        }
    })
}

/**
 * Armazena os dados do usuário no state
 *
 * @param {Function} commit
 * @param {Object} payload
 */
export const ActionSetUser = ({ commit }, payload) => {
    storage.setLocalUser(payload)
    commit(types.SET_USER, payload)
}

/**
 * Armazena o token no state
 *
 * @param {Function} commit
 * @param {Object} payload
 */
export const ActionSetToken = ({ commit }, payload) => {
    storage.setLocalToken(payload)
    storage.setHeaderToken(payload)
    commit(types.SET_TOKEN, payload)
}

/**
 * Realiza o logout do usuário
 *
 * @param {Function} dispatch
 */
export const ActionSignOut = ({ dispatch }) => {
    storage.setHeaderToken('')
    storage.deleteLocalToken('')
    dispatch('ActionSetUser', {})
    dispatch('ActionSetToken', '')

    return services.auth.logout()
}

/**
 * Atualiza o state com os dados do localStorage
 *
 * @param {Function} commit
 */
export const ActionUpdateState = ({ commit }) => {
    return new Promise(async (resolve, reject) => {
        try {
            const payload = {
                token: storage.getLocalToken(),
                user: storage.getLocalUser()
            }

            await commit(types.SET_TOKEN, payload.token)
            await commit(types.SET_USER, payload.user)

            resolve(payload)
        } catch (err) {
            reject(err)
        }
    })
}
